/**
* UpsellController
* @namespace gplans.store.controllers
*/
import * as moment from 'moment-timezone';

(function () {
  'use strict';UpsellController.$inject = ["$http", "$state", "$stateParams", "$analytics", "$localStorage", "$rootScope", "$window", "gplansConf", "Authentication", "Profile", "Mealplan", "TempCheckin", "$uibModal", "currency", "Funnel", "mesSystem", "MeasurementSystem", "UserService"];

  angular.
  module('gplans.store.controllers').

  controller('ErrorUpsellModalCtrl', ["$scope", "$uibModalInstance", "message", function ($scope, $uibModalInstance, message) {
    $scope.message = message;
    $scope.close = close;

    function close() {
      $uibModalInstance.dismiss('close');
    }
  }]).

  controller('UpsellNutritionistOldModalCtrl', ["$analytics", "$scope", "$rootScope", "$uibModalInstance", "$timeout", "$localStorage", "$state", "$window", "$ocLazyLoad", "Profile", "Funnel", "UserService", "upsellNutritionistPrice", function (
  $analytics,
  $scope,
  $rootScope,
  $uibModalInstance,
  $timeout,
  $localStorage,
  $state,
  $window,
  $ocLazyLoad,
  Profile,
  Funnel,
  UserService,
  upsellNutritionistPrice)
  {
    $scope.close = close;
    $scope.selectSlot = selectSlot;
    $scope.slots = [];
    $scope.slots_loading = false;
    $scope.phone = UserService.data.cell_phone;
    $scope.errorPhone = '';
    $scope.message = '';
    $scope.purchaised = false;
    $scope.booking = false;
    $scope.currentTimezone = moment.tz.guess();
    $scope.titleDayOfWeek = '';
    $scope.titleDate = '';
    $scope.states = {
      phone: true,
      date: false,
      time: false };

    var date;
    var setmore_customer_key;

    $scope.onChangeState = function (state) {
      for (var key in $scope.states) {
        if (key === state) {
          $scope.states[key] = true;
        } else {
          $scope.states[key] = false;
        }
      }
    };

    function activateDatepicker() {
      $timeout(function () {
        jQuery('.startDate').datepicker({
          startDate: new Date(),
          autoclose: true,
          todayHighlight: true,
          todayBtn: "linked",
          date: new Date() }).
        on('changeDate', function (ev) {
          $scope.slots_loading = true;
          date = $('.startDate').val();
          var from_tips = true;
          Profile.getTimeslots(date, from_tips).then(function (res) {
            $scope.slots = res.data;
            $scope.onChangeState('time');
            for (var i = 0; i < $scope.slots.length; i++) {
              var slot = date + ' ' + $scope.slots[i].time_slot;
              var sloteDate = moment(slot).tz('America/Los_Angeles');
              $scope.slots[i].time_slot_in_tz =
              moment.tz(slot, "MM/DD/YYYY HH:mm", "America/Los_Angeles").tz($scope.currentTimezone).format("hh:mm A");
            }
            if (sloteDate) {
              $scope.titleDayOfWeek = sloteDate.tz($scope.currentTimezone).format('dddd');
              $scope.titleDate = sloteDate.tz($scope.currentTimezone).format('MMMM Do YYYY');
            }
            $scope.slots_loading = false;
          });
        });
        jQuery('.input-group-addon').click(function (event) {
          event.preventDefault();
          jQuery('.startDate').focus();
        });
      }, 100);

      $scope.showDatePicker = function () {
        jQuery('.startDate').datepicker('show');
      };
    }

    function selectSlot(slot) {
      if (!$scope.phone) {$scope.errorPhone = 'Please, enter phone number';return;}
      date = $('.startDate').val();
      if (confirm('Are you sure to book consultation at ' + slot.time_slot_in_tz.toString())) {
        var customer = {
          email_id: UserService.data.email,
          first_name: UserService.data.first_name,
          last_name: UserService.data.last_name,
          cell_phone: $scope.phone };

        $scope.booking = true;
        Profile.createSetmoreCustomer(customer).then(function (res) {
          if (!res.data.error)
          setmore_customer_key = res.data.data.customer.key;
          if (setmore_customer_key || UserService.data.setmore_customer_key) {
            UserService.data.cell_phone = $scope.phone;
            if (!setmore_customer_key) setmore_customer_key = UserService.data.setmore_customer_key;else
            UserService.data.setmore_customer_key = setmore_customer_key;
            Profile.update(UserService.data).then(function (res) {
              var appointment = {
                start_time: date + ' ' + slot.time_slot,
                customer_key: setmore_customer_key,
                staff_key: slot.staff_key,
                price: upsellNutritionistPrice };

              Profile.createSetmoreAppointment(appointment).then(function (res) {
                if (upsellNutritionistPrice == 299)
                {
                  if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 299 });
                  $window.VWO = $window.VWO || [];
                  $window.VWO.push(['track.revenueConversion', "299"]);

                  close();
                  Funnel.nextStep();
                  $analytics.eventTrack('Upsell Nutritionist Purchased');
                } else

                {
                  if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 99 });
                  $window.VWO = $window.VWO || [];
                  $window.VWO.push(['track.revenueConversion', "99"]);

                  close();
                  Funnel.nextStep();
                  $analytics.eventTrack('Downsell Nutritionist Purchased');
                }
              });
            });
          } else $scope.message = 'You already registered at Setmore. Please, contact support.';
        });
      }
    }

    activateDatepicker();

    function close() {
      $uibModalInstance.dismiss('close');
    }
  }]).
  controller('UpsellController', UpsellController);

  UpsellController.$inject = ['$http', '$state', '$stateParams', '$analytics', '$localStorage', '$rootScope', '$window', 'gplansConf', 'Authentication', 'Profile', 'Mealplan', 'TempCheckin', '$uibModal', 'currency', 'Funnel', 'mesSystem', 'MeasurementSystem', 'UserService'];


  /**
                                                                                                                                                                                                                                                                                    * @namespace UpsellController
                                                                                                                                                                                                                                                                                    */
  function UpsellController($http, $state, $stateParams, $analytics, $localStorage, $rootScope, $window, gplansConf, Authentication, Profile, Mealplan, TempCheckin, $uibModal, currency, Funnel, mesSystem, MeasurementSystem, UserService) {
    var vm = this;
    var orderSubmitting = false;
    vm.mesSystem = mesSystem;

    activate();

    function activate() {
      vm.goalWeight = UserService.data.goal_weight;
      if (mesSystem == 'SI') {
        vm.weightUnit = 'kg';
        vm.looseWeight = Math.round(MeasurementSystem.convertLbsToKg(vm.looseWeight));
        vm.goalWeight = Math.round(MeasurementSystem.convertLbsToKg(vm.goalWeight));
      } else
      {
        vm.weightUnit = 'pounds';
      }

      // we don't wan't intercom messages on this page
      //if (window.Intercom) {
      //  window.Intercom('shutdown');
      //  delete window.Intercom;
      //}
      if ($rootScope.offerId == 'straightSale')
        //vm.noThanksLink = 'survey.question({surveyId:1, question:1})';
        vm.noThanksLink = 'base.store_account_info({plan: vm.planSlug})';else

      vm.noThanksLink = 'gplans.userConsole';

      vm.planSlug = $stateParams.plan || $localStorage['plan'] || gplansConf.defaultPlan;
      vm.goalWeight = localStorage.goal_weight;
      vm.payment_method = $localStorage['payment_method'] || 'STRIPE';
      vm.upsellNutritionistCost = 299;
      vm.upsellNutritionistRetailCost = 600;
      vm.downNutritionistCost = 99;
      vm.downNutritionistRetailCost = 299;
      //RENAMED FOR KICKOFFCALL
      vm.upsellKickOffCallCost = 99;
      vm.upsellKickOffCallRetailCost = 299;
      vm.upsellNutritionistPrice = 299;

      Authentication.check();

      if (currency == 'GBP') {
        vm.currencySymbol = '£';
        vm.retailCost = 89.99;
        vm.cost = 39.99;
        vm.downCost = 25.99;
        vm.downRetailCost = 75.99;
        //RENAMED FOR ACCELERATOR
        vm.downsellAcceleratorCost = 25.99;
        vm.upsellAcceleratorCost = 25.99;
        vm.upsellAcceleratorRetailCost = 75.99;
        vm.bundleCost = 50;
        vm.bundleRetailCost = 110;
      } else
      if (currency == 'AUD' || currency == 'CAD') {
        vm.currencySymbol = currency + '$';
        vm.retailCost = 99.99;
        vm.cost = 49.99;
        vm.downCost = 29.99;

        //RENAMED FOR ACCELERATOR
        vm.downsellAcceleratorCost = 29.99;
        vm.upsellAcceleratorCost = 29.99;
        vm.upsellAcceleratorRetailCost = 79.99;
        vm.bundleCost = 80;
        vm.bundleRetailCost = 150;
      } else
      {
        vm.currencySymbol = '$';
        vm.retailCost = 99.99;
        vm.cost = 49.99;
        vm.downCost = 29.99;
        vm.downRetailCost = 79.99;
        //RENAMED FOR ACCELERATOR
        vm.downsellAcceleratorCost = 29.99;
        vm.upsellAcceleratorCost = 79.99;
        vm.upsellAcceleratorRetailCost = 99.99;
        vm.bundleCost = 60;
        vm.bundleRetailCost = 120;
      }
    }


    function next() {
      TempCheckin.setDay();
      Mealplan.updatePlans().then(function () {
        $state.go('gplans.userConsole');
      });
    }

    var upsellSuccess = function upsellSuccess(res) {
      orderSubmitting = false;
      if (Object.keys(res.data).length == 0) {
        vm.openErrorUpsellModal("There was a problem processing your card. You bank had not authorized the payment.");
      } else {
        $analytics.eventTrack('Upsell Purchased');
        if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 50 });
        $window.VWO = $window.VWO || [];
        $window.VWO.push(['track.revenueConversion', "50"]);

        Authentication.check().then(function () {
          Funnel.nextStep(next, vm.planSlug);
        });
      }
    };

    var upsellWithFollowUpSuccess = function upsellWithFollowUpSuccess(res) {
      orderSubmitting = false;
      if (Object.keys(res.data).length == 0) {
        vm.openErrorUpsellModal("There was a problem processing your card. You bank had not authorized the payment.");
      } else {
        $analytics.eventTrack('Upsell Purchased');
        if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 50 });
        $window.VWO = $window.VWO || [];
        $window.VWO.push(['track.revenueConversion', "50"]);

        $state.go('base.store_upsell_next');
      }
    };

    var upsellBundleSuccess = function upsellBundleSuccess(res) {
      orderSubmitting = false;
      if (Object.keys(res.data).length == 0) {
        vm.openErrorUpsellModal("There was a problem processing your card. You bank had not authorized the payment.");
      } else
      if (res.data.error) {vm.openErrorUpsellModal(res.data.error);} else
      {
        $analytics.eventTrack('Upsell Bundle Purchased');
        if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 60 });
        $window.VWO = $window.VWO || [];
        $window.VWO.push(['track.revenueConversion', "60"]);

        Authentication.check().then(function () {
          TempCheckin.setDay();
          Mealplan.updatePlans().then(function () {
            //$state.go('gplansApp.dashboard.index');
            //vm.newDesignMiscAndRedirectToIndex();
            $state.go('gplans.userConsole');
          });
        });
      }
    };

    var upsellDownSuccess = function upsellDownSuccess(res) {
      orderSubmitting = false;
      if (Object.keys(res.data).length == 0) {
        vm.openErrorUpsellModal("There was a problem processing your card. You bank had not authorized the payment.");
      } else {
        $analytics.eventTrack('Upsell Down Purchased');
        if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 30 });
        $window.VWO = $window.VWO || [];
        $window.VWO.push(['track.revenueConversion', "30"]);

        Authentication.check().then(function () {
          TempCheckin.setDay();
          Mealplan.updatePlans().then(function () {
            Funnel.nextStep();
          });
        });
      }
    };

    vm.openErrorUpsellModal = function (_message) {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'md',
        templateUrl: 'templates/store/upsell-error.modal.html',
        controller: 'ErrorUpsellModalCtrl',
        resolve: {
          message: function message() {
            return _message;
          } } });


    };

    vm.openUpsellNutritionistModal = function (message) {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'md',
        templateUrl: 'templates/store/upsell-nutritionist.modal.html',
        controller: 'UpsellNutritionistOldModalCtrl',
        resolve: {
          upsellNutritionistPrice: function upsellNutritionistPrice() {
            return vm.upsellNutritionistPrice;
          } } });


    };

    var upsellError = function upsellError(err) {
      orderSubmitting = false;
      console.log(err && err.data ? err.data.detail : err, {});
      vm.openErrorUpsellModal("Error during purchase. Try once more or contact support.");
    };

    vm.upsell = function (amount) {
      Profile.getMisc('twoWeeksAccelerator').then(
      function (res) {vm.openErrorUpsellModal("This product is already purchased.");},
      function (err) {
        if (!orderSubmitting) {
          orderSubmitting = true;
          Profile.purchaseUpsell(amount).then(upsellSuccess, upsellError);
        }
      });
    };

    vm.getUpsellPaypalTokenRequest = function (amount) {
      return {
        method: 'post',
        url: gplansConf.API_URL + '/api/v1/paypal/payment/create/',
        json: {
          amount: angular.isDefined(amount) ? amount : vm.cost,
          currency: currency,
          description: '2-week Accelerator Program' } };


    };

    vm.getUpsellNutritionistPaypalTokenRequest = function () {
      return {
        method: 'post',
        url: gplansConf.API_URL + '/api/v1/paypal/payment/create/',
        json: {
          amount: vm.upsellNutritionistCost,
          currency: currency,
          description: 'Booking initial consultation' } };


    };

    vm.getDownsellNutritionistPaypalTokenRequest = function () {
      return {
        method: 'post',
        url: gplansConf.API_URL + '/api/v1/paypal/payment/create/',
        json: {
          amount: vm.downNutritionistCost,
          currency: currency,
          description: 'Booking initial consultation' } };


    };

    vm.getDownsellPaypalTokenRequest = function (amount) {
      return {
        method: 'post',
        url: gplansConf.API_URL + '/api/v1/paypal/payment/create/',
        json: {
          amount: angular.isDefined(amount) ? amount : vm.downCost,
          currency: currency,
          description: '2-week Accelerator Program' } };


    };

    vm.onUpsellPaypalSuccessBase = function (response, upsellFn) {
      var params = {
        payment_id: response.paymentID,
        payer_id: response.payerID };

      $http.post(gplansConf.API_URL + '/api/v1/paypal/payment/execute/',
      params).then(function (result) {
        if (result.data.success) {
          upsellFn();
        } else
        {
          vm.openErrorUpsellModal("There was a problem processing your payment.");
        }
      },
      function (err) {
        vm.openErrorUpsellModal("There was a problem processing your payment.");
      });

    };

    vm.onUpsellPaypalSuccess = function (response) {
      Profile.getMisc('twoWeeksAccelerator').then(
      function (res) {vm.openErrorUpsellModal("This product is already purchased.");},
      function (err) {
        if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 50 });
        $window.VWO = $window.VWO || [];
        $window.VWO.push(['track.revenueConversion', "50"]);

        vm.onUpsellPaypalSuccessBase(response, vm.upsell);
      });
    };

    vm.onDownsellPaypalSuccess = function (response) {
      Profile.getMisc('twoWeeksAccelerator').then(
      function (res) {vm.openErrorUpsellModal("This product is already purchased.");},
      function (err) {
        if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 30 });
        $window.VWO = $window.VWO || [];
        $window.VWO.push(['track.revenueConversion', "30"]);

        vm.onUpsellPaypalSuccessBase(response, vm.downsell);
      });
    };

    vm.getUpsellNextPaypalTokenRequest = function () {
      return {
        method: 'post',
        url: gplansConf.API_URL + '/api/v1/paypal/agreement/create/',
        json: {
          plan: currency == 'USD' ? 'power' : 'power-' + currency.toLowerCase() } };



    };

    vm.onUpsellNextPaypalSuccess = function (response) {
      var paymentToken = response.paymentToken;
      if (!orderSubmitting) {
        orderSubmitting = true;
        Profile.purchaseUpsellBundle(paymentToken).then(upsellBundleSuccess, upsellError);
      }
    };


    vm.onUpsellWithFollowUpPaypalSuccess = function (response) {
      Profile.getMisc('twoWeeksAccelerator').then(
      function (res) {vm.openErrorUpsellModal("This product is already purchased.");},
      function (err) {
        if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 50 });
        $window.VWO = $window.VWO || [];
        $window.VWO.push(['track.revenueConversion', "50"]);

        vm.onUpsellPaypalSuccessBase(response, vm.upsellWithFollowUp);
      });
    };

    vm.onUpsellNutritionistPaypalSuccess = function (response) {
      Profile.getMisc('upsellNutritionist').then(
      function (res) {
        if (UserService.data.setmore_customer_key)
        vm.openErrorUpsellModal("This product is already purchased.");else
        {
          vm.openUpsellNutritionistModal();
        }
      },
      function (err) {
        if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 299 });
        $window.VWO = $window.VWO || [];
        $window.VWO.push(['track.revenueConversion', "299"]);

        vm.onUpsellPaypalSuccessBase(response, upsellNutritionist);
      });
    };

    vm.onDownsellNutritionistPaypalSuccess = function (response) {
      Profile.getMisc('upsellNutritionist').then(
      function (res) {
        if (UserService.data.setmore_customer_key)
        vm.openErrorUpsellModal("This product is already purchased.");else
        {
          vm.upsellNutritionistPrice = 99;
          vm.openUpsellNutritionistModal();
        }
      },
      function (err) {
        if (window.fbq) fbq('track', 'Search', { currency: 'USD', value: 99 });
        $window.VWO = $window.VWO || [];
        $window.VWO.push(['track.revenueConversion', "99"]);

        vm.onUpsellPaypalSuccessBase(response, downsellNutritionist);
      });
    };

    vm.upsellWithFollowUp = function () {
      Profile.getMisc('twoWeeksAccelerator').then(
      function (res) {vm.openErrorUpsellModal("This product is already purchased.");},
      function (err) {
        if (!orderSubmitting) {
          orderSubmitting = true;
          Profile.purchaseUpsell().then(upsellWithFollowUpSuccess, upsellError);
        }
      });
    };

    vm.upsellNext = function () {
      // TODO
      if (!orderSubmitting) {
        orderSubmitting = true;
        Profile.purchaseUpsellBundle().then(upsellBundleSuccess, upsellError);
      }
    };

    vm.downsell = function (amount) {
      // TODO
      if (!orderSubmitting) {
        orderSubmitting = true;
        Profile.purchaseUpsellDown(amount).then(upsellDownSuccess, upsellError);
      }
    };

    vm.upsellNutritionistStripe = function () {
      Profile.getMisc('upsellNutritionist').then(
      function (res) {
        if (!UserService.data.setmore_customer_key) {
          vm.openUpsellNutritionistModal();
        } else

        vm.openErrorUpsellModal("This product is already purchased.");
      },
      function (err) {
        Profile.purchaseUpsellNutritionist().then(onUpsellNutritionistSuccess, upsellError);
      });
    };

    vm.downsellNutritionistStripe = function () {
      Profile.getMisc('upsellNutritionist').then(
      function (res) {
        if (!UserService.data.setmore_customer_key) {
          vm.openUpsellNutritionistModal();
        } else

        vm.openErrorUpsellModal("This product is already purchased.");
      },
      function (err) {
        vm.upsellNutritionistPrice = 99;
        Profile.purchaseDownsellNutritionist().then(onDownsellNutritionistSuccess, upsellError);
      });
    };

    var onUpsellNutritionistSuccess = function onUpsellNutritionistSuccess(res) {
      if (Object.keys(res.data).length == 0) {
        vm.openErrorUpsellModal("There was a problem processing your card. You bank had not authorized the payment.");
      } else {
        if (res.data.amount == 9900) {
          vm.upsellNutritionistPrice = 99;
        }
        vm.openUpsellNutritionistModal();
      }
    };

    var onDownsellNutritionistSuccess = function onDownsellNutritionistSuccess(res) {
      if (Object.keys(res.data).length == 0) {
        vm.openErrorUpsellModal("There was a problem processing your card. You bank had not authorized the payment.");
      } else {
        vm.openUpsellNutritionistModal();
      }
    };

    var upsellNutritionist = function upsellNutritionist() {
      Profile.getMisc('upsellNutritionist').then(
      function (res) {
        vm.openErrorUpsellModal("This product is already purchased.");
      },
      function (err) {
        Profile.purchaseUpsellNutritionist().then(onUpsellNutritionistSuccess, upsellError);
      });
    };

    var downsellNutritionist = function downsellNutritionist() {
      Profile.getMisc('upsellNutritionist').then(
      function (res) {
        vm.openErrorUpsellModal("This product is already purchased.");
      },
      function (err) {
        vm.upsellNutritionistPrice = 99;
        Profile.purchaseDownsellNutritionist().then(onDownsellNutritionistSuccess, upsellError);
      });
    };

  }
})();